








import { Component, Mixins, Vue } from 'vue-property-decorator'
import TeacherForm from '@/components/admin/organisms/TeacherForm.vue'
import TeacherListApis, { TeacherData } from '@/mixins/requests/admin/TeacherListApis.vue'

@Component({
  components: {
    TeacherForm,
  },
})
export default class TeacherEdit extends Mixins(TeacherListApis) {
  private teacherData: TeacherData = {
    branch: {
      branchId: 0,
      branchName: '',
      branchCode: '',
    },
  }

  private get teacherId() {
    return this.$route.params['teacherId']
  }

  private async mounted() {
    this.teacherData = await this.getTeacher(this.teacherId)
  }

  /**
   * 保存ボタン処理
   */
  private async save() {
    Vue.prototype.$loading.start()
    try {
      await this.updateTeacher(this.teacherData)
      alert('保存が完了しました')
      this.$router.push({
        name: 'AdminTeacherList',
        params: { branchId: this.teacherData.branch.branchId.toString() },
      })
    } catch (e: any) {
      if (e.response.data.status === 400) {
        alert(e.response.data.message.join('\n'))
      } else {
        alert('保存中にエラーが発生しました')
      }
    } finally {
      Vue.prototype.$loading.complete()
    }
  }

  /**
   * キャンセル処理
   */
  private cancel() {
    this.$router.push({
      name: 'AdminTeacherList',
      params: { branchId: this.teacherData.branch.branchId.toString() },
    })
  }
}
